import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class DataService {

  public datosMatricula:any;

  public errorProcesoNoExistente:any;

  public spinnerGeneral:boolean=true;

  public datosEdicionUsuario:any;

  public rolesUsuario!:string[];

}
